import React from 'react'
import Header from '../../Components/Header/Header'
import WinnersLottery from '../../Components/WinnersLottery/WinnersLottery'
import Footer from '../../Components/Footer/Footer'

const CustomerWin = () => {
  return (
    <div>
        <Header />
        <WinnersLottery />
        <Footer />
      
    </div>
  )
}

export default CustomerWin;
